/* RC: GAD buying guides (spec 13). Shared behaviour for the rc-guide-* sections:
   - measures whatever the theme pins to the top of the window (sticky header, announcement
     bar) and publishes it as --rcg-head, so the chapter bar and the pinned figure sit under it
     (the same approach as game-apparel.com's ANSI guide: measured, not assumed); --rcg-bars adds
     the chapter bar's own height, for the compare table's column headings that stick under both;
   - chapter bar: highlights the chapter in view;
   - job picker: tiles switch the answer panel; #job-<key> in the URL preselects one;
   - ladder: the active class is the last one whose top has passed the pinned drawing's line;
   - day/night: the range input moves the clip line;
   - compare: feature chips filter the table rows and the phone cards together;
   - sizes by style: the search box and the family chips filter the rows. */
(function () {
  'use strict';

  var roots = document.querySelectorAll('.rc-guide');
  if (!roots.length) return;

  /* ---- header measure ---- */
  var lastHead = -1, lastBars = -1, headTick = false;
  function measureHead() {
    var bars = [];
    document.querySelectorAll('body > *, body > * > *').forEach(function (el) {
      /* never the guide's own sticky bars: the chapter-bar section docks under the header, and
         counting it would push it down by its own height (the 2026-10-01 gap) */
      if (el.closest('.rc-guide') || el.querySelector('.rc-guide')) return;
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      /* a bar: wide, near the top, and not a full-screen overlay such as Dawn's cart drawer */
      if (r.height < 10 || r.height > window.innerHeight * 0.5 || r.width < window.innerWidth * 0.5 || r.top > window.innerHeight * 0.3) return;
      bars.push(r);
    });
    bars.sort(function (a, b) { return a.top - b.top; });
    var px = 0;
    bars.forEach(function (r) { if (r.top <= px + 4 && r.bottom > px) px = r.bottom; });
    px = Math.min(Math.round(px), Math.round(window.innerHeight * 0.25));
    var chap = document.querySelector('.rc-guide-chap-section');
    var bars = px + (chap ? chap.offsetHeight : 0);
    if (px !== lastHead || bars !== lastBars) {
      lastHead = px;
      lastBars = bars;
      /* on the root so the sticky chapter-bar section (outside .rc-guide) sees it too */
      document.documentElement.style.setProperty('--rcg-head', px + 'px');
      document.documentElement.style.setProperty('--rcg-bars', bars + 'px');
    }
  }
  function headSoon() {
    if (headTick) return;
    headTick = true;
    requestAnimationFrame(function () { headTick = false; measureHead(); });
  }
  measureHead();
  window.addEventListener('scroll', headSoon, { passive: true });
  window.addEventListener('resize', headSoon);
  window.addEventListener('load', headSoon);

  /* ---- chapter bar ---- */
  document.querySelectorAll('[data-rc-guide-chapters]').forEach(function (bar) {
    var links = Array.prototype.slice.call(bar.querySelectorAll('a[href^="#"]'));
    var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    if (!links.length) return;
    function update() {
      var line = (lastHead > 0 ? lastHead : 0) + bar.offsetHeight + window.innerHeight * 0.25;
      var best = -1;
      targets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top <= line) best = i; });
      links.forEach(function (a, i) { a.classList.toggle('is-on', i === best); });
    }
    var tick = false;
    window.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () { tick = false; update(); });
    }, { passive: true });
    update();
  });

  /* ---- job picker ---- */
  document.querySelectorAll('[data-rc-guide-jobs]').forEach(function (sec) {
    var tiles = sec.querySelectorAll('[data-rc-job]');
    var panels = sec.querySelectorAll('[data-rc-job-panel]');
    function show(key, focus) {
      tiles.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-rc-job') === key ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-rc-job-panel') !== key; });
      if (focus) {
        var open = sec.querySelector('[data-rc-job-panel="' + key + '"]');
        if (open) open.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
    tiles.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-rc-job'), false); }); });
    var m = /^#job-([a-z0-9-]+)$/i.exec(location.hash || '');
    if (m && sec.querySelector('[data-rc-job="' + m[1] + '"]')) {
      show(m[1], false);
      var el = sec;
      setTimeout(function () { el.scrollIntoView({ block: 'start' }); }, 50);
    }
  });

  /* ---- ladder ---- */
  document.querySelectorAll('[data-rc-guide-ladder]').forEach(function (sec) {
    var rungs = Array.prototype.slice.call(sec.querySelectorAll('[data-rc-rung]'));
    var figs = sec.querySelectorAll('[data-rc-fig]');
    var cap = sec.querySelector('[data-rc-fig-cap]');
    var pin = sec.querySelector('[data-rc-pin]');
    if (!rungs.length) return;
    var current = null;
    function activate(r) {
      if (r === current) return;
      current = r;
      var key = r.getAttribute('data-rc-rung');
      rungs.forEach(function (x) { x.classList.toggle('is-on', x === r); });
      figs.forEach(function (f) { f.classList.toggle('is-on', f.getAttribute('data-rc-fig') === key); });
      if (cap) cap.textContent = r.getAttribute('data-rc-rung-label') || '';
    }
    function pick() {
      var line = pin ? pin.getBoundingClientRect().top + 40 : window.innerHeight * 0.4;
      var best = rungs[0];
      rungs.forEach(function (r) { if (r.getBoundingClientRect().top <= line) best = r; });
      activate(best);
    }
    var tick = false;
    window.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () { tick = false; pick(); });
    }, { passive: true });
    window.addEventListener('resize', pick);
    pick();
  });

  /* ---- measure tabs ---- */
  document.querySelectorAll('[data-rc-guide-meas]').forEach(function (sec) {
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('[data-rc-meas-tab]'));
    var panels = sec.querySelectorAll('[data-rc-meas-panel]');
    function show(k) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-rc-meas-tab') === k ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-rc-meas-panel') !== k; });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t.getAttribute('data-rc-meas-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        n.focus();
        show(n.getAttribute('data-rc-meas-tab'));
      });
    });
  });

  /* ---- day / night ---- */
  document.querySelectorAll('[data-rc-guide-dn]').forEach(function (box) {
    var input = box.querySelector('input[type="range"]');
    if (!input) return;
    function set() { box.style.setProperty('--split', input.value + '%'); }
    input.addEventListener('input', set);
    set();
  });

  /* ---- compare: filter chips (a row stays when it has every chip that is on) ---- */
  document.querySelectorAll('[data-rc-guide-cmp]').forEach(function (box) {
    var chips = Array.prototype.slice.call(box.querySelectorAll('[data-rcg-chip]'));
    var rows = box.querySelectorAll('[data-rcg-row]');
    var cnt = box.querySelector('[data-rcg-cnt]');
    var clr = box.querySelector('[data-rcg-clear]');
    var total = box.getAttribute('data-total') || '0';
    /* sticky column headings need the window as the scroll container: the wrapper gives up its
       sideways scroll (.is-fit) only while the table fits in it; re-checked on resize and after
       a filter, since the columns size to their rows */
    var wrap = box.querySelector('.rc-guide-cmp__tbl');
    var table = wrap && wrap.querySelector('table');
    function fit() {
      if (!table) return;
      wrap.classList.toggle('is-fit', table.offsetWidth <= wrap.clientWidth + 1);
    }
    fit();
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
    function run() {
      var on = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })
        .map(function (c) { return c.getAttribute('data-rcg-chip'); });
      var n = 0;
      rows.forEach(function (r) {
        var keys = ' ' + (r.getAttribute('data-rcg-keys') || '') + ' ';
        var ok = on.every(function (k) { return keys.indexOf(' ' + k + ' ') >= 0; });
        r.hidden = !ok;
        if (ok && r.getAttribute('data-rcg-row') === 'tbl') n++;
      });
      if (cnt) {
        cnt.textContent = on.length
          ? (box.getAttribute('data-some') || '').replace('[n]', n).replace('[total]', total)
          : (box.getAttribute('data-all') || '').replace('[n]', total);
      }
      if (clr) clr.hidden = !on.length;
      fit();
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
        run();
      });
    });
    if (clr) clr.addEventListener('click', function () {
      chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      run();
    });
  });

  /* ---- sizes by style: search + family chips ---- */
  document.querySelectorAll('[data-rc-guide-sizes]').forEach(function (sec) {
    var q = sec.querySelector('[data-rcg-q]');
    var chips = Array.prototype.slice.call(sec.querySelectorAll('[data-rcg-fam]'));
    var fams = sec.querySelectorAll('[data-rcg-famsec]');
    var empty = sec.querySelector('[data-rcg-empty]');
    var fam = '';
    function run() {
      var t = ((q && q.value) || '').trim().toLowerCase();
      var any = 0;
      fams.forEach(function (f) {
        if (fam && f.getAttribute('data-rcg-famsec') !== fam) { f.hidden = true; return; }
        var n = 0;
        f.querySelectorAll('[data-rcg-item]').forEach(function (it) {
          var ok = !t || (it.getAttribute('data-q') || '').indexOf(t) >= 0;
          it.hidden = !ok;
          if (ok) n++;
        });
        f.hidden = !n;
        any += n;
      });
      if (empty) empty.hidden = any > 0;
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        fam = c.getAttribute('data-rcg-fam') || '';
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        run();
      });
    });
    if (q) q.addEventListener('input', run);
  });
})();
